import clsx from "clsx";

import styles from "./oldBrowserModal.module.scss";
import { ChevronTop } from "@monta/icons";

import type { AccordionButtonProps } from "@monta/design-system";
interface LabelButtonProps extends AccordionButtonProps {
  title: string;
}
const LabelButton = (props: LabelButtonProps) => {
  const { title, active, onClick } = props;
  return (
    <button
      onClick={onClick}
      className={clsx(styles["label"], active && styles["label--active"])}
    >
      <span>{title}</span>
      <ChevronTop
        className={clsx(
          styles["label__icon"],
          active && styles["label__icon--rotate"]
        )}
      />
    </button>
  );
};
export default LabelButton;
